import useMessageHistory from '@/hooks/conversations/use-message-history';
import useMessageWebSocketDispatch from '@/hooks/conversations/use-message-web-socket-dispatch';
import { useIsUploadingFile } from '@/hooks/files/use-upload-file';
import useSession from '@/hooks/sessions/use-session';
import useFriendInfo from '@/hooks/users/use-friend-info';
import type { ConversationSessionType } from '@/models/conversations/conversation-session';
import { useFriendBySessionId } from '../contacts/use-friends';

export function useSessionMessages(sessionId?: number, searchId?: number) {
  const { session } = useSession<ConversationSessionType>('session', sessionId);
  const { friend } = useFriendBySessionId(sessionId);

  const {
    friendInfo,
    isLoading: isFriendLoading,
    error: friendInfoError,
  } = useFriendInfo(session?.UserID || friend?.FriendID);

  const { isLoading: isHistoryLoading, error: historyError } = useMessageHistory('session', sessionId, searchId);
  const isUploadingFile = useIsUploadingFile();

  return {
    friendInfo,
    session,
    isHistoryLoading,
    isLoading: isUploadingFile || isHistoryLoading || isFriendLoading,
    error: historyError ?? friendInfoError,
  } as const;
}
